import { OnChanges, OnInit } from '@angular/core';
var GaugeChartComponent = /** @class */ (function () {
    function GaugeChartComponent() {
        this.value = 0;
        this.isDecimal = true;
    }
    GaugeChartComponent.prototype.ngOnInit = function () {
        if (this.isDecimal) {
            this.value = this.value * 100;
        }
        this.changeColor();
    };
    GaugeChartComponent.prototype.ngOnChanges = function () {
        this.changeColor();
    };
    GaugeChartComponent.prototype.changeColor = function () {
        if (this.value >= 75) {
            this.color = '#1a61f7';
        }
        else if (this.value >= 50) {
            this.color = '#e4771f';
        }
        else {
            this.color = '#fc3868';
        }
    };
    return GaugeChartComponent;
}());
export { GaugeChartComponent };
